import { Box, Typography } from '@mui/material';
import reviewDecorIcon from '../../../assets/svg/main/review_decor.svg';
import reviewStarsGreenIcon from '../../../assets/svg/main/review_stars_green.svg';

function ReviewBadge() {
  return (
    <Box
      sx={{
        padding: '20px',
        background: '#fff3dd',
        borderRadius: '24px',
        marginBottom: '20px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: '12px',
        }}
      >
        <img src={reviewDecorIcon} alt="decor" />
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '2px',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Avenir Next',
              fontSize: '24px',
              fontWeight: 700,
              color: '#232631',
            }}
          >
            1.2 Million
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Avenir Next',
              fontSize: '14px',
              fontWeight: 400,
              color: '#232631',
              textAlign: 'center',
            }}
          >
            Users improved their account metrics with our application
          </Typography>
        </Box>
        <img
          style={{ transform: 'scaleX(-1)' }}
          src={reviewDecorIcon}
          alt="decor"
        />
      </Box>

      <Box
        sx={{
          background: '#fff',
          borderRadius: '12px',
          padding: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          textAlign: 'center',
        }}
      >
        <img src={reviewStarsGreenIcon} alt="decor" />
        <Box
          sx={{
            mt: '10px',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Avenir Next',
              fontSize: '16px',
              lineHeight: 'normal',
              color: '#232631',
              fontWeight: 600,
              span: {
                color: '#FFB21D',
              },
            }}
          >
            <span>4.8</span> out of 5
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Avenir Next',
              fontSize: '14px',
              lineHeight: 'normal',
              color: '#232631',
              fontWeight: 400,
              mt: '5px',
            }}
          >
            Based on thousands of reviews from our satisfied users
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default ReviewBadge;
